module.exports = __webpack_public_path__ + "img/appAsset-brand--webpay.411f5df7.svg";